const initalState = {
    isLogin: false,
    apiKeys: null,
    userData: null
}

export const security = (state=initalState, action) => {
    switch(action.type){
        case "LOGIN":
            return {
                isLogin: true,
                apiKeys: action.apiKey,
                userData: action.data
            };
        case "LOGOUT":
            return {
                isLogin: false,
                apiKeys: action.apiKey,
                userData: action.data
            };
        default:
            return state;
    }
};